import DatePicker from "@/components/ui/date-picker";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { cn } from "@/lib/utils";
import type { FieldValues, Path, UseFormReturn } from "react-hook-form";

interface DateFieldProps<TFieldValues extends FieldValues> {
  form: UseFormReturn<TFieldValues>;
  name: Path<TFieldValues>;
  label: string;
  placeholder?: string;
  className?: string;
  maxDate?: Date;
}

const DateField = <TFieldValues extends FieldValues>({
  form,
  name,
  label,
  placeholder = "Selecione uma data",
  className,
  maxDate,
}: DateFieldProps<TFieldValues>) => (
  <FormField
    control={form.control}
    name={name}
    render={({ field }) => (
      <FormItem className={cn("flex flex-col", className)}>
        <FormLabel>{label}</FormLabel>
        <FormControl>
          <DatePicker
            value={typeof field.value === "string" ? field.value : ""}
            onChange={field.onChange}
            onBlur={field.onBlur}
            placeholder={placeholder}
            maxDate={maxDate}
          />
        </FormControl>
        <FormMessage />
      </FormItem>
    )}
  />
);

export default DateField;
